export default "__VITE_ASSET__BQPkjQW4__"